import React from 'react';
import { useAuth } from '../../providers/auth-provider';

function ParticipationHeader() {
  const { isDevelop } = useAuth();
  return (
    <div className="d-flex pt-4 pb-2 w-100 justify-content-center sticky-top bg-light">
      <h1 className="display-4">{isDevelop() ? 'Leader ' : 'Candidate '} Assessment Participation</h1>
    </div>
  );
}

export default ParticipationHeader;
